import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface WarningConfirmationDialogModel {
	title: string;
	content: string;
	cancelBtnText?: string;
	okBtnText?: string;
}

@Component({
	selector: "app-warning-confirmation-dialog",
	templateUrl: "./warning-confirmation-dialog.component.html",
	styleUrls: ["./warning-confirmation-dialog.component.scss"],
	standalone: false
})
export class WarningConfirmationDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<WarningConfirmationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: WarningConfirmationDialogModel
	) {}

	onCancelClick(): void {
		this.dialogRef.close(false);
	}

	onProceedClick(): void {
		this.dialogRef.close(true);
	}
}
